<template>
  <div class="profile-menu">
    <!-- 프로필 헤더 -->
    <div class="profile-header">
      <img class="profile-avatar" :src="member_info.image" alt="프로필" />
      <div class="profile-info">
        <span class="profile-name">{{ member_info.nickname }}</span>
        <span class="profile-email">{{ member_info.mb_id }}</span>
      </div>
    </div>
    
    <a class="view-profile" @click="oth_showProfileDialog(true)">
      내 프로필 보기
    </a>

    <div class="divider"></div>

    <!-- 메뉴 리스트 -->
    <ul class="menu-list">
      <li @click="oth_showMyAssets(true)">
        <i class="ph ph-wallet"></i>
        <span>내 자산</span>
      </li>
      <li @click="oth_showCowClicker(true)">
        <i class="ph ph-game-controller"></i>
        <span>게임</span>
      </li>
      <li @click="oth_showAlarmList(true)">
        <i class="ph ph-bell"></i>
        <span>알림</span>
      </li>
      <li @click="goToSubscription">
        <i class="ph ph-credit-card"></i>
        <span>구독 플랜</span>
      </li>
      <li @click="goToSetting">
        <i class="ph ph-gear"></i>
        <span>설정</span>
      </li>
      <li @click="oth_showBugReport(true);">
        <i class="ph ph-bug"></i>
        <span>버그 제보</span>
      </li>
    </ul>

    <div class="divider"></div>

    <ul class="menu-list">
      <li @click="fnLogout">
        <i class="ph ph-sign-out"></i>
        <span>로그아웃</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { inject } from "vue";

export default {
  props: {
    oth_showProfileDialog: {
      type: Function,
      default: () => {}
    },
    oth_showCowClicker: {
      type: Function,
      default: () => {}
    },
    oth_showAlarmList: {
      type: Function,
      default: () => {}
    },
    oth_showBugReport: {
      type: Function,
      default: () => {}
    },
    oth_showMyAssets: {
      type: Function,
      default: () => {}
    }
  },
  setup() {
    const logout = inject("logout");
    const member_info = inject("member_info");

    function fnLogout() {
      logout();
    }

    function goToSetting() {
      window.location.href = '/setting';
    }

    function goToSubscription() {
      window.location.href = '/subscription';
    }

    return {
      fnLogout,
      member_info,
      goToSetting,
      goToSubscription
    };
  },
};
</script>

<style scoped>
.profile-menu {
  position: absolute;
  right: var(--font-size-md);
  top: var(--font-size-5xl);
  width: 280px;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(24px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  z-index: 999;
  overflow: hidden;
}

/* 프로필 헤더 */
.profile-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px;
}

.profile-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
}

.profile-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.profile-name {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.profile-email {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
}

/* 프로필 보기 링크 */
.view-profile {
  display: block;
  padding: 0 18px 16px;
  font-size: 14px;
  color: var(--color-brand, #3ea6ff);
  cursor: pointer;
  text-decoration: none;
}

.view-profile:hover {
  text-decoration: underline;
}

/* 구분선 */
.divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
}

/* 메뉴 리스트 */
.menu-list {
  list-style: none;
  margin: 0;
  padding: 8px 0;
}

.menu-list > li {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 18px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.menu-list > li:hover {
  background: rgba(255, 255, 255, 0.1);
}

.menu-list > li > i {
  font-size: 20px;
  color: #fff;
  width: 24px;
  text-align: center;
}

.menu-list > li > span {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}
</style>